import React, { useCallback } from 'react';
import { GroupSearchResult } from 'graphql/types';
import { GroupSelectCount } from '../constant';
import { useGroupSelectLabel } from '../hooks/useGroupSelectType';
import { GroupSelect } from '../GroupSelect';
import { GroupSelectDropdownProp } from '../types';
import { useSelectSearchAction } from './hooks/useSelectSearchAction';

const emptyData: GroupSearchResult[] = [];

export const DivisionsSelect: React.FC<GroupSelectDropdownProp> = ({
  groupType,
  rowID,
  defaultValues,
  classes
}: GroupSelectDropdownProp) => {
  const {
    searchHandler,
    data: { divisions: divisionsData },
    loading: { divisions: divisionsLoading }
  } = useGroupSelectLabel();

  const divisions = divisionsData?.groupsSearch?.divisions.items || emptyData;
  const hasMore = divisions.length === GroupSelectCount;
  const { handleSearch } = useSelectSearchAction(searchHandler);

  const onOpen = useCallback(() => {
    handleSearch(groupType, null);
  }, [groupType, handleSearch]);

  return (
    <GroupSelect
      groupType={groupType}
      onOpen={onOpen}
      handleSearch={handleSearch}
      options={divisions}
      hasMore={hasMore}
      loading={divisionsLoading}
      rowID={rowID}
      defaultValues={defaultValues}
      classes={classes}
    />
  );
};
